import Vue from 'vue'

import EditorViewItemHolder from '@broker/blockFormEditor/ui/render/EditorViewItemHolder.vue';


// we register globally to avoid recursive component issues
Vue.component('EditorViewItemHolder', EditorViewItemHolder)
